<template>
  <div>
    <navbar class="navbar" />
    <v-card class="mb-5">
      <v-card-text>
        <h3>รายงานสินค้า</h3>
        <v-row>
          <v-divider style="margin: 10px 0"></v-divider>
        </v-row>

        <v-row>
          <v-col class="col-3">
            <router-link :to="{ name: 'ReportProductMenu' }" tag="span">
              <a>Product</a>
            </router-link>
          </v-col>
          <v-col class="col-9">
            รายงานสินค้า
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import script from '@/views/pages/reports/index.script';

export default script;
</script>
